"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePhotoViewer = void 0;
var React = require("react");
var PhotoViewerModal_1 = require("./components/PhotoViewerModal");
var usePhotoViewer = function () {
    var _a = React.useState({ popupVisible: false, loading: false, imgSrc: "" }), state = _a[0], setState = _a[1];
    var ResolveComplete = React.useRef();
    var handleOnClose = function () {
        setState(__assign(__assign({}, state), { popupVisible: false }));
        ResolveComplete.current();
    };
    var showPhotoViewer = function (imgSrc) {
        return new Promise(function (resolve) {
            if (typeof imgSrc === "string") {
                setState({ imgSrc: imgSrc, loading: false, popupVisible: true });
            }
            else {
                setState(__assign(__assign({}, state), { loading: true, popupVisible: true }));
                imgSrc().then(function (result) {
                    setState({ imgSrc: result, loading: false, popupVisible: true });
                });
            }
            ResolveComplete.current = resolve;
        });
    };
    var PhotoViewer = function (staticProps) {
        return state.popupVisible ?
            React.createElement(PhotoViewerModal_1.PhotoViewerModal, __assign({}, staticProps, { ImgSource: state.imgSrc, LoadingSource: state.loading, OnClose: handleOnClose }))
            :
                React.createElement(React.Fragment, null);
    };
    return { PhotoViewer: PhotoViewer, showPhotoViewer: showPhotoViewer };
};
exports.usePhotoViewer = usePhotoViewer;
